import { Component, computed, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CutOffConfig, TimeSlot } from '../../nexpe.model';
import { TimeslotRowComponent } from '../timeslot-row/timeslot-row.component';

@Component({
  selector: 'app-cutoff-editor',
  imports: [TranslateModule, TimeslotRowComponent],
  templateUrl: './cutoff-editor.component.html',
  styleUrl: './cutoff-editor.component.scss',
})
export class CutoffEditorComponent {
  cutOff = input<CutOffConfig | null>(null);
  cutOffChange = output<CutOffConfig>();

  private localTimeSlots = signal<TimeSlot[]>([]);

  timeSlots = computed(() => {
    const cutOff = this.cutOff();
    if (cutOff && cutOff.timeSlots.length > 0) {
      return cutOff.timeSlots;
    }
    return this.localTimeSlots();
  });

  addTimeSlot(): void {
    const newSlot: TimeSlot = {
      startCutOffHour: 0,
      fixedCutOffHour: 0,
      fixedCutOffDelayedDays: 0,
      delayedCutOffHours: null,
    };

    const current = this.timeSlots();
    const updated = [...current, newSlot];
    this.emitChange(updated);
  }

  onTimeSlotChange(event: { index: number; timeSlot: TimeSlot }): void {
    const current = [...this.timeSlots()];
    current[event.index] = event.timeSlot;
    this.emitChange(current);
  }

  onDeleteSlot(index: number): void {
    const current = this.timeSlots().filter((_, i) => i !== index);
    this.emitChange(current);
  }

  private emitChange(timeSlots: TimeSlot[]): void {
    this.localTimeSlots.set(timeSlots);
    this.cutOffChange.emit({ timeSlots });
  }
}
